const AppInfoModel = require("./event.appinfo.js");
const AppPerformanceModel = require("./event.appperformance.js");
const DeviceModel = require("./event.device.js");
const NetworkInfoModel = require("./event.network");
const SessionModel = require("./event.session.js");

class EventModel {
  constructor({
    account_balances = {},
    account_type = null,
    app = null,
    app_environment = null,
    app_info = new AppInfoModel(),
    app_performance = new AppPerformanceModel(),
    cart = {},
    cart_id = null,
    channel = null,
    ciam_id = null,
    client_event_date = null,
    client_event_timestamp = null,
    device = new DeviceModel(),
    device_token = null,
    email_id = null,
    event_name = null,
    event_params = {},
    network = new NetworkInfoModel(),
    session = new SessionModel(),
    transaction_id = null,
    user_country = null,
    user_id = null,
    user_properties = null,
  } = {}) {
    this.account_balances = account_balances;
    this.account_type = account_type;
    this.app = app;
    this.app_environment = app_environment;
    this.app_info = app_info;
    this.app_performance = app_performance;
    this.cart = cart;
    this.cart_id = cart_id;
    this.channel = channel;
    this.ciam_id = ciam_id;
    this.device = device;
    this.device_token = device_token;
    this.email_id = email_id;
    this.channel = channel;
    this.client_event_date = client_event_date;
    this.client_event_timestamp = client_event_timestamp;
    this.event_name = event_name;
    this.event_params = event_params;
    this.network = network;
    this.session = session;
    this.transaction_id = transaction_id;
    this.user_country = user_country;
    this.user_id = user_id;
    this.user_properties = user_properties;
  }

  json() {
    return {
      project_id: this.app,
      environment: this.app_environment,
      event: {
        account_balances: this.account_balances,
        account_type: this.account_type,
        app_info: this.app_info,
        app_performance: this.app_performance,
        cart: this.cart,
        cart_id: this.cart_id,
        channel: this.channel,
        ciam_id: this.ciam_id,
        client_event_date: this.client_event_date,
        client_event_timestamp: this.client_event_timestamp,
        device: this.device,
        device_token: this.device_token,
        email_id: this.email_id,
        event_name: this.event_name,
        event_params: this.event_params,
        network: this.network,
        session: this.session,
        transaction_id: this.transaction_id,
        user_country: this.user_country,
        user_id: this.user_id,
        user_properties: this.user_properties,
      },
    };
  }
}

module.exports = EventModel;
